import * as types from './form.actionType';
import * as commonActionType from '@common/store/common/common.actionsType';
import PubSub from 'pubsub-js';
import { takeEvery, put } from 'redux-saga/effects';

export default workSaga;

function* workSaga() {
  yield takeEvery(types.FORM_INSERTED_SUCCESS, inserted);
  yield takeEvery(types.FORM_INSERTED_SUCCESS_NOSCROLL, insertedNoScroll);
  yield takeEvery(types.FORM_UPDATED_SUCCESS, updated);
  yield takeEvery(types.FORM_UPDATED_SUCCESS_NOSCROLL, updatedNoScroll);
  yield takeEvery(types.FORM_RELOAD, reload);
  yield takeEvery(types.FORM_RESET, resetAction);
  yield takeEvery(types.FORM_GRID_RELOAD, gridReload);
  yield takeEvery(types.FORM_REDIRECT, redirect);
  yield takeEvery(types.FORM_DELETED_SUCCESS, deleted);
  yield takeEvery(types.FORM_DELETED_SUCCESS_NOSCROLL, deletedNoScroll);
  yield takeEvery(types.FORM_ASSOCIATE_SUCCESS, associate);
  yield takeEvery(types.FORM_DISASSOCIATE_SUCCESS, disassociate);
  yield takeEvery(types.FORM_DISASSOCIATE_SUCCESS_NOSCROLL, disassociateNoScroll);
  yield takeEvery(types.FORM_TREEVIEW_RELOAD, treeviewReload);
  yield takeEvery(types.FORM_MASSASSOCIATE_SUCCESS, massAssociate);
  yield takeEvery(types.FORM_INTEGRATION_SUCCESS, integration);
  yield takeEvery(types.FORM_REJECTION_SUCCESS, rejection);
  yield takeEvery(types.FORM_EXIGENCIA_SUCCESS, exigencia);
  yield takeEvery(types.FORM_GERADO_SUCCESS, gerado);
  yield takeEvery(types.FORM_DEFERIDO, deferido);
  yield takeEvery(types.FORM_IGNORE_SUCCESS, ignore);
  yield takeEvery(types.FORM_REACTIVED_SUCCESS, reactivated);
  yield takeEvery(types.FORM_CANCEL_SUCCESS, cancel);
  yield takeEvery(types.FORM_REACTIVATE_SUCCESS, reactivate);
  yield takeEvery(types.RESET_FORM, resetForm);
  yield takeEvery(types.FORM_CIENTIZAR, cientizar);
  yield takeEvery(types.FORM_CANCELAR, cancelar);
  yield takeEvery(types.FORM_ERRO, erro);
  yield takeEvery(types.FORM_WARNING, warning);
  yield takeEvery(types.FORM_INFO, info);
  yield takeEvery(types.FORM_GRID_SET_SELECTEDITENS, setSelectedItens);
  yield takeEvery(types.RESET_HASH_FORM, resetHashForm);
  yield takeEvery(types.RESET_FORMCONTROL, resetFormControl);
  yield takeEvery(types.IMAGE_INSERTED_SUCCESS, imageInserted);
  yield takeEvery(types.IMAGE_REMOVED_SUCCESS, imageRemoved);
  yield takeEvery(types.FORM_APROVADO_SUCCESS, aprovado);
  yield takeEvery(types.FORM_CANCELADO_SUCCESS, cancelado);
  yield takeEvery(types.FORM_RECUSADO_SUCCESS, recusado);
  yield takeEvery(types.FORM_GRID_RESET, gridReset);
}

function* inserted(action) {
  _alert.success(action.payload || 'Registro incluído com sucesso.');
}

function* insertedNoScroll(action) {
  _alert.successNoScroll(action.payload || 'Registro incluído com sucesso.');
}

function* updated(action) {
  _alert.success(action.payload || 'Registro alterado com sucesso.');
}

function* updatedNoScroll(action) {
  _alert.successNoScroll(action.payload || 'Registro alterado com sucesso.');
}

function* deleted(action) {
  _alert.success(action.payload || 'Registro removido com sucesso.');
}

function* deletedNoScroll(action) {
  _alert.successNoScroll(action.payload || 'Registro removido com sucesso.');
}

function* associate(action) {
  _alert.success(action.payload || 'Registro associado com sucesso.');
}

function* massAssociate(action) {
  _alert.success(action.payload || 'Registros associados com sucesso.');
}

function* disassociate(action) {
  _alert.success(action.payload || 'Registro desassociado com sucesso.');
}

function* disassociateNoScroll(action) {
  _alert.successNoScroll(action.payload || 'Registro desassociado com sucesso.');
}

function* ignore(action) {
  _alert.success(action.payload || 'Registro ignorado com sucesso.');
}

function* reactivated(action) {
  _alert.success(action.payload || 'Registro reativado com sucesso.');
}

function* rejection(action) {
  _alert.success(action.payload || 'Registro indeferido com sucesso.');
}

function* exigencia(action) {
  _alert.success(action.payload || 'Exigência enviada com sucesso.');
}

function* deferido(action) {
  _alert.success(action.payload || 'Registro deferido com sucesso.');
}

function* integration(action) {
  _alert.success(action.payload || 'Integração realizada com sucesso.');
}

function* cancel(action) {
  _alert.success(action.payload || 'Registros cancelados com sucesso.');
}

function* reactivate(action) {
  _alert.success(action.payload || 'Registros reativados com sucesso.');
}

function* cancelar(action) {
  _alert.success(action.payload || 'Registro cancelado com sucesso.');
}

function* cientizar(action) {
  _alert.success(action.payload || 'Registro cientizado com sucesso.');
}

function* gerado(action) {
  _alert.success(action.payload || 'Registro gerado com sucesso.');
}

function* erro(action) {
  _alert.error(action.payload);
}

function* warning(action) {
  _alert.warning(action.payload);
}

function* info(action) {
  _alert.info(action.payload);
}

function* resetForm(action) {
  PubSub.publish(commonActionType.RESET_FORM, { hash: action.payload });
}

function* resetHashForm(action) {
  PubSub.publish(commonActionType.RESET_HASH_FORM, { hash: action.payload });
}

function* resetAction() {
  PubSub.publish(commonActionType.VALIDATION_RESET);
}

function* reload() {
  yield put({
    type: commonActionType.RESET,
  });
  PubSub.publish(commonActionType.RESET_FORM);
}

function* gridReload(action) {
  PubSub.publish(commonActionType.GRID_RELOAD, action.payload);
}

function* gridReset(action) {
  PubSub.publish(commonActionType.GRID_RESET, action.payload);
}

function* treeviewReload(action) {
  PubSub.publish(commonActionType.TREEVIEW_RELOAD, action.payload);
}

function* redirect(action) {
  const { payload } = action;
  window.isRedirectSaga = true;
  PubSub.publish(commonActionType.REDIRECT, payload);
}

function* setSelectedItens(action) {
  PubSub.publish(commonActionType.GRID_SELECTEDITENS_SET, action.payload);
}

function* resetFormControl(action) {
  window.formUpdated = false;
}

function* imageInserted(action) {
  _alert.success(action.payload || 'Imagem incluída com sucesso.');
}

function* imageRemoved(action) {
  _alert.success(action.payload || 'Imagem removida com sucesso.');
}

function* aprovado() {
  _alert.success('Registro Aprovado com sucesso.');
}

function* cancelado() {
  _alert.success('Registro Cancelado com sucesso.');
}

function* recusado() {
  _alert.success('Registro Recusado com sucesso.');
}
